import React, { FC } from 'react';

import { IRoundGroup } from '../../../../../../store/admin/eventRounds/store';

import { useTeeSheetCreatorState } from '../../Context/TeeSheetCreator.context';
import Group from '../Group/Group';

export const IndividualGroups: FC = () => {
  const { filteredGroups } = useTeeSheetCreatorState();

  return (
    <>
      {filteredGroups.map((group: IRoundGroup) => (
        <Group key={`round-group-${group.id}`} group={group} />
      ))}
    </>
  );
};
